import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { k8sMonthlyPriceColumnDef } from "./common/k8sMonthlyPriceColumnDef";
import { k8sClusterColumnDef } from "./common/k8sClusterColumnDef";
import { k8sLabelsColumnDef } from "./common/k8sLabelsColumnDef";
import { regionColumnDef } from "../common/regionColumnDef";
import { MoneyCellRenderer } from "../column-def-cell-renderers/money/MoneyCellRenderer";
import { FilteredKubernetesNodeResourceItem } from "@/services/cloudchipr.api";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { getResourceMetricsColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceMetricsColumnDef";
import { metricsHeaderCellTooltips } from "@/components/pages/common/resource-details/utils/constants/metricsHeaderCellTooltips";

export const k8sNodeColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("Node Name"),

  k8sMonthlyPriceColumnDef,

  {
    field: "resource.idle_monthly_cost",
    headerName: "Idle Monthly Price",
    cellRenderer: ({
      data,
    }: ICellRendererParams<FilteredKubernetesNodeResourceItem>) => {
      return <MoneyCellRenderer money={data?.resource?.idle_monthly_cost} />;
    },
  },

  k8sClusterColumnDef,

  { field: "resource.architecture", headerName: "Architecture" },

  getResourceMetricsColumnDef(
    "CPU Utilization Max",
    "cpu_percent",
    "kubernetes_node",
    metricsHeaderCellTooltips.get("kubernetes_node")?.cpu,
  ),

  getResourceMetricsColumnDef(
    "Memory Utilization Max",
    "memory_used_percent",
    "kubernetes_node",
    metricsHeaderCellTooltips.get("kubernetes_node")?.mem_used,
  ),

  { field: "resource.instance_type", headerName: "Instance Type" },

  regionColumnDef,

  k8sLabelsColumnDef,
];
